import { tv } from '@costar-ui/cosmos';
import { cardBodyStyles } from './card-body/card-body.styles.esm.js';
import { cardBodyWrapperStyles } from './card-body-wrapper/card-body-wrapper.styles.esm.js';
import { cardFooterStyles } from './card-footer/card-footer.styles.esm.js';
import { cardHeaderStyles } from './card-header/card-header.styles.esm.js';
import { cardImageStyles } from './card-image/card-image.styles.esm.js';
import baseCard from './theme/base-card.esm.js';
import nextCard from './theme/next-card.esm.js';

var baseCardRoot = tv(baseCard);
var nextCardRoot = tv(nextCard);
var base = {
  root: baseCardRoot,
  body: cardBodyStyles.base,
  bodyWrapper: cardBodyWrapperStyles.base,
  footer: cardFooterStyles.base,
  header: cardHeaderStyles.base,
  image: cardImageStyles.base
};
var next = {
  root: nextCardRoot,
  body: cardBodyStyles.base,
  bodyWrapper: cardBodyWrapperStyles.base,
  footer: cardFooterStyles.base,
  header: cardHeaderStyles.base,
  image: cardImageStyles.base
};
var cardStyles = {
  base: base,
  next: next
};

export { cardStyles };
//# sourceMappingURL=card.styles.esm.js.map
